<h3>Settings</h3>
<p-divider></p-divider>
<h6 class="mt-0">Component Scale</h6>
<div class="config-scale justify-content-center">
  <p-button
    icon="pi pi-minus"
    (click)="decrementScale()"
    styleClass="p-button-rounded p-button-text"
    [disabled]="this.themeService.config.fontSize === scales[0]"
  ></p-button>
  <i
    *ngFor="let item of scales"
    class="pi pi-circle-fill"
    [ngClass]="{ 'scale-active': item === this.themeService.config.fontSize }"
  ></i>

  <p-button
    icon="pi pi-plus"
    (onClick)="incrementScale()"
    styleClass="p-button-rounded p-button-text"
    [disabled]="this.themeService.config.fontSize === scales[scales.length - 1]"
  ></p-button>
</div>
<h6>Dark Mode</h6>
<p-inputSwitch [ngModel]="this.themeService.config.dark" (onChange)="changeTheme($event.checked)"></p-inputSwitch>
